
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { Getter, Mutation } from 'vuex-class';

import { Periodo } from '../../bower_components/teknisavuecomponents/assets/interfaces/interfaces';

@Component({
    name: 'SelectPeriodoComponent'
})
class SelectPeriodoComponent extends Vue {
  // STORE
  @Getter('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtual: Periodo;

  @Getter('periodosDemonstrativo')
  private readonly periodosDemonstrativo: Periodo[];

  @Mutation('updatePeriodoDemonstrativoAtual')
  private updatePeriodoDemonstrativoAtual: (x: any) => void;

  @Emit('periodoMudou')
  private periodoOnChange(periodo: string) {
    const periodoAtual = this.periodosDemonstrativo.find((p: any) => p.value === periodo);
    this.updatePeriodoDemonstrativoAtual(periodoAtual);
    return periodoAtual;
  }
}

export default SelectPeriodoComponent;
